import {
  MapTool,
  DomEventListener,
  MapUtil,
  DecorationFactory
} from "cartovista";
import {createStyle} from "../utils/CvUtils";
import "../../css/MapTarget.css";﻿

    export default class MapTarget extends MapTool {
      constructor(mapTargetBtnHtml, styleConfig, keepSelection) {
        super(mapTargetBtnHtml, {
          "map": window.cartovista.externalInterface.map,
          "mapController": window.cartovista.getMapController(window.cartovista.externalInterface.map)}, {"spriteCssClass": "bi bi-geo"});
        this._map = window.cartovista.externalInterface.map;
        this.selection = null;
        this.selectionLayer = null;
        this._keepSelection = keepSelection;
        this._mapController = window.cartovista.getMapController(this._map);
        this._divMap = this._mapController.divMap;
        $(mapTargetBtnHtml).removeClass("k-button k-button-icon").children().removeClass("k-sprite");
        window.cartovista.getUIController(this._map).cvToggleGroup.addElement(this);
        this._createMapTargetDecoration(styleConfig);
        this._boundOnDivMapClicked = this._onDivMapClicked.bind(this);
      }

    _createMapTargetDecoration(styleConfig) {
        var symbolizers = createStyle(styleConfig).symbolizers;
        this._decoration = DecorationFactory.createSymbolPointDecoration("mapTarget", 0, 0, this._map.currentCoordinateSystem, symbolizers);
        this._decoration.visible = false;
        this._decoration._created = false;
        this._map.addDecoration(this._decoration);
    };

    _toggleMapTargetVisibility(value) {
        this._decoration.visible = value;
    };

    _activated() {
        if (this._keepSelection) {
            window.cartovista.toggleClusteringActivatedLayers(false);
            this.selectionLayer.selectFeatures(this.selection, false);
            this.toggleOn();
        }
        DomEventListener.addListener(this._divMap, "click", this._boundOnDivMapClicked, this);
        DomEventListener.addListener(this._divMap, "touchend", this._boundOnDivMapClicked, this);
        $(this._divMap).addClass("MapTarget_active");
    };

    _deactivated() {
        DomEventListener.removeListener(this._divMap, "click", this._boundOnDivMapClicked, this);
        DomEventListener.removeListener(this._divMap, "touchend", this._boundOnDivMapClicked, this);
        $(this._divMap).removeClass("MapTarget_active");
    };

    //TODO: infoPanTool n'est pas toujours présent dans la carte. Utiliser le mapTool sélectionné par défaut à l'ouverture de la carte
    _onDivMapClicked(e) {
        var MouseCoordinates = this.getNormalizedMouseCoordinates(e);
        var x = Math.round(MapUtil.screenXtoMapX(MouseCoordinates.x, this._mapController._map.width, this._mapController._map.extent));
        var y = Math.round(MapUtil.screenYtoMapY(MouseCoordinates.y, this._mapController._map.height, this._mapController._map.extent));
        this._decoration.setPosition(x, y);
        this._decoration._created = true;
        this._decoration.visible = true;
        window.cartovista.getUIController(this._map).findInstance("infoPanTool").toggleOn();
    };
}
